var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139:2386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7496 11.8781C18.7496 13.6281 17.6996 13.753 17.4997 13.753H2.13165L5.43774 10.447L4.55654 9.5595L0.181749 13.9343C-0.060583 14.1781 -0.060583 14.5717 0.181749 14.8155L4.55654 19.1903L5.43774 18.3091L2.13165 15.003H17.4997C18.3621 15.003 19.9995 14.378 19.9995 11.8781V10.0032H18.7496V11.8781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25092 8.12832C1.25092 6.37841 2.30086 6.25341 2.50085 6.25341H17.8689L14.5628 9.5595L15.444 10.4407L19.8188 6.06592C20.0611 5.82214 20.0611 5.42849 19.8188 5.18472L15.444 0.809929L14.5565 1.69739L17.8689 5.00347H2.50085C1.6384 5.00347 0.000976562 5.62844 0.000976562 8.12832V10.0032H1.25092V8.12832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139:2386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchange);
export default __webpack_public_path__ + "static/media/icon-exchange.167c24d9141f82380383d49430a1a713.svg";
export { ForwardRef as ReactComponent };